import React, { useState, useEffect } from 'react';

const ErrorBoundary = ({ children }) => {
	const [hasError, setHasError] = useState(false);
	useEffect(() => {
		const logError = (error, errorInfo) => {
			// Call your logService function here
			// logService(error, errorInfo);
			console.error(error, errorInfo);
		};

		if (hasError) {
			// Perform any necessary error handling or logging
			logError();
		}
	}, [hasError]);

	const handleOnError = (error, errorInfo) => {
		setHasError(true);
		// Optionally, you can log the error here as well
		// logService(error, errorInfo);
		console.error(error, errorInfo);
	};

	return hasError ? <h1>Something went wrong.</h1> : <div onError={handleOnError}>{children}</div>;
};

export default ErrorBoundary;
